import SiteNav from '@/components/organisms/SiteNav'
import FooterStub from '@/components/organisms/FooterStub'

interface StubPageProps {
    title: string;
}

// Placeholder destination for a Resources nav item — nav, page title, a
// clearly marked coming-soon placeholder, and footer, per instruction. No
// invented copy: title is the nav label, placeholder text is literal.
// Internal sign-off only — must not be cut over to a real, publicly-linked
// route until real content exists. See docs/build-log.md.
export function StubPage({ title }: StubPageProps) {
    return (
        <div className="min-h-screen bg-unimo-stone">
            <div className="site-shell">
                <SiteNav />

                <section className="pt-section-gap pb-section-gap">
                    <h1 className="max-w-2xl text-4xl font-medium text-unimo-slate lg:text-5xl">{title}</h1>
                    <div className="mt-8 max-w-2xl rounded-site-card border-[3px] border-unimo-site-grey-300 bg-white p-8 text-center font-light text-unimo-site-grey-700">
                        Content coming soon.
                    </div>
                </section>

                <FooterStub />
            </div>

        </div>
    )
}

export default StubPage
